import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Checkbox, Modal, Typography } from 'antd'
import { toast } from 'react-toastify'
import { useAuthStore } from '@/stores/authStore'
import { aceitarContrato } from '@/api/parceiros'

const { Title, Paragraph } = Typography

export function Contrato() {
  return (
    <div className="min-h-screen bg-white">
      <ContratoHeader />
      <ContratoContent />
    </div>
  )
}

function ContratoHeader() {
  return (
    <div className="bg-[#1a3a5c] text-white px-8 py-4">
      <span className="font-semibold">New Driver — Painel de Parceiros</span>
    </div>
  )
}

function ContratoContent() {
  const [welcomeOpen, setWelcomeOpen] = useState(true)

  return (
    <div className="max-w-3xl mx-auto p-8">
      <WelcomeModal open={welcomeOpen} onClose={() => setWelcomeOpen(false)} />
      <ContratoTexto />
      <ContratoAceite />
    </div>
  )
}

function WelcomeModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} footer={null} closable={false} centered>
      <div className="text-center py-4">
        <Title level={4}>Prazer, New Driver!</Title>
        <Paragraph className="text-gray-600">
          Que bom você estar aqui. Antes de começar, alguns ajustes...
        </Paragraph>
        <Paragraph>
          <strong>Leitura e aceite de nosso contrato</strong>
        </Paragraph>
        <Paragraph className="text-gray-500 text-sm">
          Estamos a um passo de crescermos juntos. Sem surpresas e notas de rodapé confusas.
        </Paragraph>
        <Button type="primary" size="large" onClick={onClose} className="mt-2">
          Estou pronto. Vamos lá!
        </Button>
      </div>
    </Modal>
  )
}

function ContratoTexto() {
  const parceiro = useAuthStore((s) => s.parceiro)

  return (
    <div className="border border-gray-200 rounded-lg p-6 mb-6 text-sm leading-relaxed">
      <Title level={4} className="text-center !mb-6">
        CONTRATO DE AGENTE AUTORIZADO NEW DRIVER
      </Title>

      <Paragraph>
        <strong>PARTE 1 — AGENTE AUTORIZADO:</strong>
        <br />
        Razão Social: {parceiro?.nome}
        <br />
        CNPJ: {parceiro?.cpfCnpj}
        <br />
        UF: {parceiro?.uf}
      </Paragraph>

      <Paragraph>
        <strong>PARTE 2 — NEW DRIVER:</strong>
        <br />
        NEW DRIVER LTDA
        <br />
        CNPJ: 31.665.008/0001-09
        <br />
        Rua Padre Conrado, 78, Quadra 150, Lote 11, Casa 01, Sala 202, Cidade Jardim, Goiânia-GO,
        CEP: 74413-150
        <br />
        Representada por: Géssica Bandeira da Silva Rezende
      </Paragraph>

      <Paragraph>
        <strong>CLÁUSULA PRIMEIRA — CONSIDERAÇÕES PRELIMINARES:</strong>
        <br />
        A NEW DRIVER é empresa credenciada pelo DENATRAN para oferta de cursos de formação,
        atualização e reciclagem de condutores em todo o território nacional, conforme legislação
        vigente.
      </Paragraph>

      <Paragraph>
        <strong>CLÁUSULA SEGUNDA — OBJETO:</strong>
        <br />O presente contrato autoriza o AGENTE AUTORIZADO a comercializar todos os cursos
        disponibilizados pela NEW DRIVER em sua plataforma digital, nas condições comerciais
        pactuadas entre as partes.
      </Paragraph>

      <Paragraph>
        <strong>CLÁUSULA TERCEIRA — VIGÊNCIA:</strong>
        <br />O presente contrato é celebrado por prazo indeterminado, podendo ser rescindido por
        qualquer das partes mediante aviso prévio de 30 (trinta) dias.
      </Paragraph>
    </div>
  )
}

function ContratoAceite() {
  const [aceite, setAceite] = useState(false)
  const [loading, setLoading] = useState(false)
  const { parceiro, usuario, checkSession } = useAuthStore()
  const navigate = useNavigate()

  const isAdmin = parceiro?.role === 'admin'

  async function handleAceitarContrato() {
    if (!aceite) {
      toast.error('Você precisa marcar o checkbox para aceitar o contrato.')
      return
    }
    if (!isAdmin) {
      toast.error('Apenas o sócio administrador pode aceitar o contrato.')
      return
    }
    if (!parceiro || !usuario) return

    setLoading(true)
    try {
      await aceitarContrato({
        cpfCnpj: parceiro.cpfCnpj,
        cpfUsuarioAceite: usuario.cpf,
        nome: parceiro.nome,
        telefone: parceiro.telefone,
        uf: parceiro.uf,
      })
      toast.success('Contrato aceito com sucesso.')
      await checkSession()
      navigate('/matricula')
    } catch {
      toast.error('Ocorreu um erro ao aceitar o contrato.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="space-y-4">
      {!isAdmin && (
        <p className="text-amber-600 text-sm">
          Apenas o sócio administrador pode aceitar o contrato.
        </p>
      )}

      <Checkbox checked={aceite} onChange={(e) => setAceite(e.target.checked)}>
        Li e aceito o contrato
      </Checkbox>

      <div className="flex gap-3">
        <Button style={{ width: 300 }} onClick={() => window.print()}>
          Imprimir
        </Button>
        <Button
          type="primary"
          style={{ width: 300 }}
          disabled={!aceite || !isAdmin}
          loading={loading}
          onClick={handleAceitarContrato}
        >
          Aceitar o contrato
        </Button>
      </div>
    </div>
  )
}
